import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { informationUrl } from '~/utils/licensePlateRenewalHelpers';

const LicencePlateRenewal = () => {
    const router = useRouter();

    useEffect(() => {
        router.push(informationUrl, undefined, { locale: router.locale });
    });

    return <>/</>;
};

export default LicencePlateRenewal;
